const TYPE = 'tpi.HeadCount'

function create() {
  return {
    type : TYPE
  }
}
export default {
  TYPE,
  create
}
